module.exports = __webpack_public_path__ + "img/turq-bg.9f34de9a.jpg";